import React, { useMemo } from 'react';

import { ReactComponent as Browse } from './browse.svg';
import { ReactComponent as Close } from './close.svg';

const images = {
  Browse,
  Close,
};

const Image = ({ type, color, strokeColor, onClick }) => {
  const ImageComponent = useMemo(() => {
    const ImageTag = images[type];
    return ImageTag ? <ImageTag style={{ fill: color || undefined, stroke: strokeColor || undefined }} /> : null;
  }, [type, color]);

  return (
    <div className={`img img-${type}`} onClick={onClick}>
      {ImageComponent}
    </div>
  );
};

export default React.memo(Image);
